import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "id", "value", "variant", "onChange"];
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { Select, Option } from 'components/Select';
import useUniqueId from 'hooks/useUniqueId';
function DownloadPermissionField(_ref) {
  var isDisabled = _ref.isDisabled,
    id = _ref.id,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    _onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var downloadOptions = [{
    value: 'disabled',
    title: t('state_disabled')
  }, {
    value: 'enabled',
    title: t('state_enabled')
  }, {
    value: 'required',
    title: t('state_required_no_file_preview')
  }];
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_allow_download'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(Select, {
    isDisabled: isDisabled,
    labelledById: uniqueId,
    size: "medium",
    variant: variant,
    menuPlacement: "top",
    value: value,
    onChange: function onChange(selectedItem) {
      return _onChange(selectedItem);
    },
    ml: variant === 'transparent' ? '-xxs' : undefined
  }, downloadOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.value,
      value: option.value
    }, option.title);
  })));
}
export default DownloadPermissionField;